var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 96,
    viewBox: "0 0 110 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 95.9994C18.6 95.9994 15.2 93.7494 13.55 90.4994L0.5 43.1994L0 40.9994C0 39.6733 0.526784 38.4016 1.46447 37.4639C2.40215 36.5262 3.67392 35.9994 5 35.9994H27.9L50.9 3.14941C51.361 2.47878 51.9792 1.93121 52.7005 1.55451C53.4219 1.17781 54.2245 0.983441 55.0382 0.988373C55.852 0.993305 56.6522 1.19739 57.369 1.5828C58.0857 1.96822 58.6972 2.52324 59.15 3.19941L82.1 35.9994H105C106.326 35.9994 107.598 36.5262 108.536 37.4639C109.473 38.4016 110 39.6733 110 40.9994L109.8 42.4494L96.45 90.4994C94.8 93.7494 91.4 95.9994 87.5 95.9994H22.5ZM55 14.6994L40 35.9994H70L55 14.6994ZM55 55.9994C52.3478 55.9994 49.8043 57.053 47.9289 58.9283C46.0536 60.8037 45 63.3472 45 65.9994C45 68.6516 46.0536 71.1951 47.9289 73.0705C49.8043 74.9458 52.3478 75.9994 55 75.9994C57.6522 75.9994 60.1957 74.9458 62.0711 73.0705C63.9464 71.1951 65 68.6516 65 65.9994C65 63.3472 63.9464 60.8037 62.0711 58.9283C60.1957 57.053 57.6522 55.9994 55 55.9994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketImageIcon);
export default __webpack_public_path__ + "static/media/basketImageIcon.1428fb0c00d860b224166712f93d1e93.svg";
export { ForwardRef as ReactComponent };